export const formatPrice = (value: number) => {
  const price = new Intl.NumberFormat('fi-FI', {
    style: 'currency',
    currency: 'EUR',
    maximumFractionDigits: 2,
  }).format(value)

  return price
}
